import { Stack } from "react-bootstrap"
import MenuButton from "./MenuButton"
import React from "react"

type MenuProps = {
    selected: string
    onSelected: (id: string) => void
    defs: MenuDefinition[]
    getActive: (id: string) => boolean
}

type Submenu = {
    id: string
    label: string
    icon: string
    path?: string
    element?: JSX.Element | null
}

export type MenuDefinition = {
    id: string
    label: string
    icon?: any
    path?: string
    element?: JSX.Element | null
    subs?: Submenu[] | null
}

const Menu: React.FC<MenuProps> = ({
    selected = "",
    defs,
    onSelected = (id: string) => { },
    getActive,
}) => {
    const onClicked = (_selected?: string) => {
        onSelected(_selected!)
    }
    return <Stack className="menu-container" gap={2}>
        {
            defs.map((item) =>
                getActive(item.id) && <MenuButton
                    key={item.id}
                    Icon={item.icon}
                    id={item.id}
                    checked={item.id === selected}
                    onClicked={
                        (id) => {
                            if (!item.subs || item.subs.length === 0)
                                onClicked(id)
                        }
                    }
                    text={item.label}>
                    {item.subs &&
                        <>
                            {item.subs!.map(subMenu =>
                                getActive(subMenu.id) && <MenuButton
                                    id={subMenu.id}
                                    text={subMenu.label}
                                    checked={subMenu.id === selected}
                                    onClicked={onClicked} />)}
                        </>}
                </MenuButton>)
        }
    </Stack>
}

export default Menu